import React from 'react';
import iconsSprite from '../../assets/icons-sprite.svg';

const Sprite = ({ size = 32, icon = 'world' }) => {
  let xPos;

  switch (icon) {
    case 'world':
      xPos = 0;
      break;
    case 'wallet':
      xPos = 1;
      break;
    case 'money':
      xPos = 2;
      break;
    case 'document':
      xPos = 3;
      break;
    case 'star':
      xPos = 4;
      break;
    case 'cart':
      xPos = 5;
      break;
    case 'plane':
      xPos = 6;
      break;
    case 'plusone':
      xPos = 7;
      break;
    case 'more':
      xPos = 7.99;
      break;
    case 'money-circle':
      xPos = 9;
      break;
    case 'lock':
      xPos = 10;
      break;
    case 'building':
      xPos = 11;
      break;
    case 'vip':
      xPos = 12;
      break;
    case 'person':
      xPos = 13;
      break;
    case 'chat':
      xPos = 14;
      break;
    case 'suitcase':
      xPos = 15;
      break;
    case 'tickets':
      xPos = 16;
      break;
    case 'bonus':
      xPos = 17;
      break;

    default:
      xPos = 0;
      break;
  }

  return (
    <span>
      <style jsx>{`
        span {
          display: inline-block;
          background-image: url(${iconsSprite});
          width: ${size}px;
          height: ${size}px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: -${size * xPos}px center;
        }
      `}</style>
    </span>
  );
};

export default Sprite;
